import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

$(function () {
    $('a[href^="#"').on('click', function (e) {
        let href = $(this).attr('href');
        scrollToElement(href);
        e.preventDefault();
    });

    function scrollToElement(selector) {
        if (selector === '#') {
            console.log('Smooth scroll cannot do #');
            return;
        }
        selector = selector.replaceAll('+', '_'); // javascript vind id's met een '+' niet leuk!
        let target = $(document.querySelector(selector));
        if (!target.length) {
            console.log('Smooth scroll cant find target', selector);
            return;
        }

        console.log('Scrolling to:', selector);

        let offset = $('.nav__bar').outerHeight();
        offset += $('.nav__topbar').outerHeight();
        let extraoffset = 16; // 1 rem extra offset
        let paddingmarginoffset = 0; // we willen geen rekening houden met evt. padding / margin van een element, element.offset().top doet dat wel en dat willen we juist niet.
        paddingmarginoffset += target.outerHeight(true) - target.outerHeight(); // margin top&bot
        paddingmarginoffset += target.innerHeight() - target.height(); // padding top&bot
        paddingmarginoffset += target.outerHeight() - target.innerHeight(); // border top&bot
        paddingmarginoffset /= 2; // van top&bot naar alleen top

        // selector = selector.replace('#', '');
        let top = jQuery(selector).offset().top;
        if (top === 0) {
            top = document.querySelector(selector).offsetParent.offsetTop;
        }
        console.log('Top: ', top);
        window.scrollTo({
            top: top - offset - extraoffset + paddingmarginoffset,
            left: 0,
            behavior: "smooth",
        });
    }

    if (window.location.hash !== '') {
        scrollToElement(window.location.hash);
    }

    window.smoothScroll = scrollToElement;
    window.smoothScrollTo = scrollToElement;
});
